import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ApiSdkService } from 'src/app/services/api-sdk.service';
import { OriginDetectionService } from 'src/app/services/origin-detection.service';
import { LegacyHintService } from '../../services/legacy-hint.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  loginForm!: FormGroup;

  emailToVerify: string = '';
  secretToVerify: string = '';

  constructor(
    public formBuilder: FormBuilder,
    private router: Router,
    private apiSdkService: ApiSdkService,
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private originDetection: OriginDetectionService,
    private legacyHint: LegacyHintService,
    ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      this.emailToVerify = params['email'];
      this.secretToVerify = params['secret'];

      // Work out where the visitor came from (affiliate ref, ad click id / utm tags, the landing
      // site's soft touch, or the referrer) and stash it for the register/onboarding steps.
      // Same resolver the register flow uses, so both entry points agree on precedence.
      const resolvedOrigin = this.originDetection.resolve(
        params,
        params['attr'] || localStorage.getItem('acquisition_attr'),
        document.referrer
      );
      if (resolvedOrigin) {
        localStorage.setItem('origin', JSON.stringify(resolvedOrigin));
      }

      if(this.emailToVerify && this.secretToVerify) {
        const result = await this.apiSdkService.login(this.emailToVerify, this.secretToVerify);
        if (result.success?.data) {
          localStorage.setItem('token', result.success.data);
          /* ⭐ Tell platform.totalum.app this browser belongs here — see
             `LegacyHintService`. Must sit beside EVERY token write. */
          this.legacyHint.mark();

          // Send origin data if present (for returning users with referral link)
          const storedOrigin = localStorage.getItem('origin');
          if (storedOrigin) {
            try {
              const originData = JSON.parse(storedOrigin);
              await this.apiSdkService.editUserData({ origin: originData } as any);
              localStorage.removeItem('origin');
              console.log('✅ Sent origin data for returning user via login');
            } catch (e) {
              console.error('Error sending origin data:', e);
            }
          }

          // TODO: clean url query params
          this.router.navigate(['/account']);
          setTimeout(() => {
            window.location.reload();
          },20);
        }
      }
    });

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get errorControl() {
    return this.loginForm.controls;
  }

  async onSubmit() {


    // Trigger form validation for all fields by marking them as touched
    Object.values(this.loginForm.controls).forEach(control => {
      control.markAsTouched();
    });

    // Check if the form is valid before proceeding with form submission
    if (this.loginForm.valid) {
        const recaptchaToken = await this.recaptchaV3Service.execute('login').toPromise();

        await this.apiSdkService.sendLoginUrl(this.loginForm.value.email, recaptchaToken as string);
        this.router.navigate(['/confirm-email'], {
          queryParams: { email: this.loginForm.value.email }
        });      
    }
  }

}
